export const REACT_APP_API_URL = "/api/gateway";
export const REACT_APP_FEEDBACK_API_URL = "/gateway";
export const REACT_APP_GOOGLE_RECAPTCHA_KEY =
  "6LdgGq8ZAAAAAEG8nW1r-y4kEa0za539rMxBRRwW";

export const BP_CONTAINER_PAD_X = [16, 59, null, null, 107];
export const BP_CONTAINER_PAD_Y = [16, 40, null, null, 50];
export const BP_MAX_WIDTH = "1152px";

export const MAX_CANT_ICONOS_GRANDES = 5;

export const FAQ_FEEDBACK_LOCALSTORAGE_KEY = "faq-feedback";
export const FAQ_TYPE = "Pregunta frecuente";

export const DOLAR_DATETIME_FORMAT_UI: string = "H:mm";
export const CARROUSEL_RADIUS = 8;
export const EMPTY_STRING: string = "";
export const HTML_LINE_BREAK: string = "<br>";
export const SLIDETITLE_DEFAULT_LABEL: string = "Novedad. Conocé más.";
